import React from "react";
import "./SigninWidget.css";
import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import LoginPage from "./LoginPage";

const SigninWidget = () => {


  return (
    <>
  
    <AuthenticatedTemplate>
      <div>
        {/* User is authenticated - let App.jsx handle the dashboard */}
      </div>
    </AuthenticatedTemplate>

    <UnauthenticatedTemplate>
        <LoginPage/>
    </UnauthenticatedTemplate>

    </>
  );
};

export default SigninWidget;